export default __webpack_public_path__ + "static/support-sponsor-nylife-e0dff5e64ce2d694a7773ac85de3cd9b.png";